import { Loader2 } from "lucide-react";

interface LoadMoreButtonProps {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
  /** Fetch every remaining page; renders the "Załaduj wszystkie" button when set. */
  onLoadAll?: () => void;
  isFetchingAll?: boolean;
  /** Rows currently rendered. */
  loaded: number;
  /** Rows matching the active filters server-side (meta.count). */
  total: number;
  className?: string;
}

/**
 * Footer for the paginated list views: a count line plus the "load more" button.
 *
 * The count renders whenever there are rows, so the end of a list still reads
 * "Pokazano 213 z 213"; the buttons only render while more remain. No noun after the
 * numbers on purpose — Polish needs three plural forms, and picking one per call site is
 * how "3 wyników" happens.
 */
export function LoadMoreButton({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
  onLoadAll,
  isFetchingAll = false,
  loaded,
  total,
  className = "",
}: LoadMoreButtonProps) {
  if (!total) return null;

  const btnCls =
    "flex items-center gap-2 px-5 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 transition-colors text-gray-700 dark:text-gray-300";
  const busy = isFetchingNextPage || isFetchingAll;

  return (
    <div className={`flex flex-col items-center gap-2 pt-4 ${className}`}>
      <p className="text-xs text-gray-400 dark:text-gray-500">
        Pokazano {loaded} z {total}
      </p>
      {hasNextPage && (
        <div className="flex items-center gap-2">
          <button onClick={onLoadMore} disabled={busy} className={btnCls}>
            {isFetchingNextPage && !isFetchingAll && <Loader2 size={14} className="animate-spin" />}
            Załaduj więcej
          </button>
          {onLoadAll && (
            <button onClick={onLoadAll} disabled={busy} className={btnCls}>
              {isFetchingAll && <Loader2 size={14} className="animate-spin" />}
              Załaduj wszystkie
            </button>
          )}
        </div>
      )}
    </div>
  );
}
